import { useEffect, useState } from 'react';
import { renderChildren } from "./renderChildren.js";
export function ExitTransitionPlaceholder(_ref) {
  var {
    in: inProp,
    children: childrenProp
  } = _ref;
  var [children, setChildren] = useState(childrenProp);
  useEffect(() => {
    if (inProp) {
      setChildren(childrenProp);
    }
  }, [inProp, childrenProp]);
  return renderChildren(children);
}